module.exports = __webpack_public_path__ + "img/tip-img.b40ed1e2.png";